import React from "react";

class FilePreview extends React.Component {
  state = {
    preview: null
  };

  componentDidMount() {
    this.generatePreview(this.props.file);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.file.name !== nextProps.file.name) {
      this.generatePreview(nextProps.file);
    }
  }

  generatePreview = file => {
    // Reset preview URL
    this.setState({ preview: null });

    if (/^image\//.test(file.type)) {
      const reader = new FileReader();
      reader.onload = () => {
        this.setState({
          preview: reader.result
        });
      };
      reader.readAsDataURL(file);
    }
  };

  render() {
    const { preview } = this.state;
    if (!preview) return null;
    const { file, ...otherProps } = this.props;
    return <img src={preview} alt={file.name} {...otherProps} />;
  }
}

export default FilePreview;



// WEBPACK FOOTER //
// ./src/components/FilePreview.js